enum ActivityPriority {
    None = 0,
    Low = 1,
    Normal = 2,
    High = 3,
    Urgent = 4
}

export default ActivityPriority;

export const ActivityPriorityLabels: { [key: number]: string } = {
    [ActivityPriority.None]: 'None',
    [ActivityPriority.Low]: 'Low',
    [ActivityPriority.Normal]: 'Normal',
    [ActivityPriority.High]: 'High',
    [ActivityPriority.Urgent]: 'Urgent'
};

export const ActivityPriorityColors: { [key: number]: string } = {
    [ActivityPriority.None]: 'grey',
    [ActivityPriority.Low]: 'green',
    [ActivityPriority.Normal]: 'grey',
    [ActivityPriority.High]: 'red',
    [ActivityPriority.Urgent]: 'red'
};
